<template>
  <div>
    <div class="row w-100 m-0 py-2 px-2" style="background-color:#dde2ed; border-radius:8px 8px 0px 0px;">
      <button @click="onClickNavi($event)" type="button" class="btn btn-crm-secondary btn-sm move-today mr-2  h40 w64" data-action="move-today">{{$ml.get('TODAY')}}</button>
      <!-- <select class="mr-2 btn btn-crm-secondary h40 w130 px-1" @click="viewKontrol($event)">
        <option>{{$ml.get('MONTHLY')}}</option>
        <option >{{$ml.get('WEEKLY')}}</option>
        <option>{{$ml.get('DAILY')}}</option>
      </select> -->

      <div class="h40 activityFilterr d-flex justify-content-center align-items-center" style="background-color:#fff; border-radius:0.25rem;" role="group" aria-label="activityGroupButton">
        <button :class="{active:activityFilterr=='all'}" @click="viewKontrol($event)" id="MONTHLY" type="button" class="btn btn-crm-secondary-calendar btn-sm move-today w64 mx-1" aria-pressed="true" data-action="move-today" style="height:34px;">{{$ml.get('MONTHLY')}}</button>
        <button :class="{active:activityFilterr==1}" @click="viewKontrol($event)" id="WEEKLY" type="button" class="btn btn-crm-secondary-calendar btn-sm move-today w64 mx-1" data-action="move-today" style="height:34px;">{{$ml.get('WEEKLY')}}</button>
        <button :class="{active:activityFilterr==2}" @click="viewKontrol($event)" id="DAILY" type="button" class="btn btn-crm-secondary-calendar btn-sm move-today w64 mx-1" data-action="move-today" style="height:34px;">{{$ml.get('DAILY')}}</button>
      </div>
      <button :disabled="this.cloudCalendarApiTokens.length>=1 && this.uploadCalendarControl==0 " @click="onClickNavi($event)" type="button" class="btn btn-crm-secondary move-day  h40 w40 ml-2 fas fa-angle-left" data-action="move-prev" style="border-radius:4px 0px 0px 4px;">
      </button>
      <button :disabled="this.cloudCalendarApiTokens.length>=1 && this.uploadCalendarControl==0 " @click="onClickNavi($event)" type="button" class="btn btn-crm-secondary move-day mr-2 h40 w40 fas fa-angle-right" data-action="move-next" style="border-radius:0px 4px 4px 0px;">
      </button>
      <span class="render-range f-24 pageTitle d-flex align-items-center">{{dateRange}}</span>
    </div>
    <calendar style="height:800px; border:1px solid #e5e5e5;"
              ref="tuiCal"
              :calendars="calendarList"
              :schedules="scheduleList"
              :view="view"
              :taskView="taskView"
              :scheduleView="scheduleView"
              :theme="theme"
              :week="week"
              :month="month"
              :timezones="timezones"
              :isReadOnly="isReadOnly"
              :useCreationPopup="useCreationPopup"
              :useDetailPopup="useDetailPopup"
              :template="template"
              :disableClick="disableClick"
              :disableDblClick="disableDblClick"
              @beforeDeleteSchedule='deleteSchedule'
              @beforeUpdateSchedule='beforeUpdateSchedule'
              @beforeCreateSchedule="onBeforeCreateSchedule"
          
    />
    <div ref="container">
    </div>
    <div class="row d-flex align-items-center mb-5 px-3 m-0 py-2" style="background-color:#dde2ed; border-radius:0px 0px 8px 8px;">
      <span class="aciklamaRengi mr-5"> AÇIKLAMALAR</span>
      <div class="ml-2 mr-4 my-1">
         <button type="button" class="btn callColor btn-sm">
            <i class="fa fa-phone-volume text-white"></i>
         </button>
         <span class="aciklamaRengi ml-1 ">Arama aktivitesi</span>
      </div>
      <div class="mr-4 my-1">
         <button type="button" class="btn taskColor btn-sm">
            <i class="fas fa-tasks text-white"></i>
         </button>
         <span class="aciklamaRengi ml-1">Görev aktivitesi</span>
      </div>
      <div class="mr-4 my-1">
         <button type="button" class="btn mailColor btn-sm">
            <i class="fa fa-envelope text-white"></i>
         </button>
         <span class="aciklamaRengi ml-1">E-posta aktivitesi</span>
      </div>
      <div class="mr-4 my-1">
         <button type="button" class="btn appointmentColor btn-sm">
            <i class="fas fa-calendar-check text-white"></i>
         </button>
         <span class="aciklamaRengi ml-1" >Randevu aktivitesi</span>
      </div>
      <div class="mr-4 my-1">
         <button type="button" class="btn googleColor btn-sm">
            <i class="fab fa-google text-white"></i>
         </button>
         <span class="aciklamaRengi ml-1" >Google Takvim</span>
      </div>

    </div>
  </div>
</template>
<script>
 import 'tui-calendar/dist/tui-calendar.css'
 import { Calendar } from '@toast-ui/vue-calendar';
 import axios from 'axios'
 import { mapState } from 'vuex'
 import Vue from 'vue'
 import Swal from 'sweetalert2'


// import NewActivity from './newActivity.vue';

 export default {
   name: 'myCalendar',
   components: {
     'calendar': Calendar,
      // NewActivity
   },
   data() {
     return {
       calendarList: [
         {
           id: '0',
           name: 'activities'
         }
       ],
       activities:[],
       uploadCalendarControl:0,
       cloudCalendarApiTokens:[],
       activityFilterr:'all',
       pagingSize:100,
       pagingOffset:0,
       scheduleList: [],
       view: 'month',
       taskView: false,
       scheduleView: ['time'],
       theme: {
       'month.dayname.height': '30px',
       'month.dayname.textAlign': 'center',
       'week.today.color': '#333',
       'week.daygridLeft.width': '100px',
       'week.timegridLeft.width': '100px',

       },
       week: {
         narrowWeekend: true,
         showTimezoneCollapseButton: true,
         timezonesCollapsed: false,
         daynames:['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'],
       },
       month: {
         isAlways6Week:true,
         startDayOfWeek: 0,
         daynames:['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'],
       },
       timezones: [{
         timezoneOffset: 180,
         displayLabel: 'GMT+03:00',
         tooltip: 'Seoul'
       }],
       disableDblClick: true,
       isReadOnly: false,
       template: {
          popupDelete: function() {
            return 'Sil';
       },

          popupEdit: function() {
            return ` <span data-toggle="modal" data-target="#add" @click="editLines(),modalMode='Düzenle'">Düzenle</span>`;
        },
          allday: function(schedule) {
            return `<span class="${schedule.customStyle} text-dark  mt-1 mr-1"></span><span class="mt-1">${schedule.title}</span>`;
    },
          time: function(schedule) {
            return `<span class="${schedule.customStyle}  text-dark mr-1 mt-1 "></span><span class="mt-1">${schedule.title}</span>`;
    },
       },
       useCreationPopup: false,
       useDetailPopup: true,
       usageStatistics: false,
       dateRange: '',
       disableClick:false

     }
   },
   props:["activityFilter","updateCalendar","data","tableConfigVisible","columns","cellUpdateUrl","filterGuide","page","user","users","filterDatas","permissions"],
   computed:{
     ...mapState([
       'baseUrl',
     ])
   },
   watch:{
     'activityFilter':function(){
       this.activities=[]
       this.scheduleList=[]
       this.$emit("updatedCalendar","changeActivity")

     },
      'updateCalendar':function(){
       this.activities=[]
       this.scheduleList=[]
       this.calendarF();
      
        axios({
            method: 'get',
            url: '/getAllDefaultCloudCalendarApiTokens',
            baseURL: this.baseUrl,
        }).then(response => {
            this.cloudCalendarApiTokens = response.data.content.tokens
            if(this.cloudCalendarApiTokens.length>=1){
              
              this.calendarFF()
            }
        }).catch(error => {
            console.log(error);
            this.$notify({ 
                group: 'foo',
                type: 'error', 
                title: this.$ml.get('ERROR'),
                text: error
            })
        });
      
       
     },
     dateRange:function(){
      this.$emit("updatedCalendar","updateCalendar")
     },
     view:function(){
       setTimeout(() => {
          this.setRenderRangeText();
       },100);
      // this.$emit("updatedCalendar","updateCalendar")
     }
     },
    // created(){
    //    this.listTokens()
    // },
   methods: {
        editLines(data){
        data["edit"]=true
        this.$store.dispatch('editLine', data)
        this.$store.dispatch('editLineStatu', true)
     },
    onBeforeCreateSchedule(e){
      this.useCreationPopup=true
      document.querySelector(".tui-full-calendar-popup")
      var scheduleDate=this.$moment(new Date(e.start._date)).format()
      new Date(scheduleDate).toLocaleDateString()
      this.$root.$refs.newActivities.activityDate=this.$moment(new Date(scheduleDate)).format()
      $('#add').modal('show')
     this.$emit("updatedCalendar","updateCalendar")
       
    },
    //  listTokens: function() {
    //          axios({
    //              method: 'get',
    //              url: '/getAllDefaultCloudCalendarApiTokens',
    //              baseURL: this.baseUrl,
    //          }).then(response => {
    //              console.log(response);
    //              this.cloudCalendarApiTokens = response.data.content.tokens
    //              console.log(this.cloudCalendarApiTokens );
    //          }).catch(error => {
    //              console.log(error);
    //              this.$notify({ 
    //                  group: 'foo',
    //                  type: 'error', 
    //                  title: this.$ml.get('ERROR'),
    //                  text: error
    //              })
    //          });
    //   },
     
    // activityFilterr:function(){
    //     this.$refs.filter.childFilter(this.activityFilterr,"type");
    // },
     viewKontrol(event){
       if(event.srcElement.id=='MONTHLY')
       {
         this.activityFilterr="all"
         this.view='month'
       }
       else if(event.srcElement.id=='WEEKLY')
       {
          this.activityFilterr=1
          this.view='week'
       }
       else if(event.srcElement.id=='DAILY')
       {
          this.activityFilterr=2
          this.view='day'
       }
     },
     init() {
       this.setRenderRangeText();
     },
     setRenderRangeText() {
       const {invoke} = this.$refs.tuiCal;
       const view = invoke('getViewName');
       const calDate = invoke('getDate');
       const rangeStart = invoke('getDateRangeStart');
       const rangeEnd = invoke('getDateRangeEnd');
       let year = calDate.getFullYear();
       let month = calDate.getMonth() + 1;
       let date = calDate.getDate();
       let dateRangeText = '';
       let endMonth, endDate, start, end;
       switch (view) {
         case 'month':
           dateRangeText = `${year}-${month}`;
           break;
         case 'week':
           year = rangeStart.getFullYear();
           month = rangeStart.getMonth() + 1;
           date = rangeStart.getDate();
           endMonth = rangeEnd.getMonth() + 1;
           endDate = rangeEnd.getDate();
           start = `${year}-${month}-${date}`;
           end = `${year}-${endMonth}-${endDate}`;
           dateRangeText = `${start} ~ ${end}`;
           break;
         default:
           dateRangeText = `${year}-${month}-${date}`;
       }
       this.dateRange = dateRangeText;
     },
     onClickNavi(event) {
       if(this.cloudCalendarApiTokens.length>=1){
          if (event.target.tagName === 'BUTTON' && this.uploadCalendarControl==1 ) {
            const {target} = event;
            let action = target.dataset ? target.dataset.action : target.getAttribute('data-action');
            action = action.replace('move-', '');
            this.$refs.tuiCal.invoke(action);
            this.setRenderRangeText();
          }
       }
       else{
           if (event.target.tagName === 'BUTTON') {
            const {target} = event;
            let action = target.dataset ? target.dataset.action : target.getAttribute('data-action');
            action = action.replace('move-', '');
            this.$refs.tuiCal.invoke(action);
            this.setRenderRangeText();
          }
       }
      
     },
     deleteSchedule(event){
       if("$can('can_delete_contacts')"){
            var confirm_message = this.$ml.get('DELETE_ACTIVITY_CONFIRM')
            Swal.fire({
            title: this.$ml.get('DELETE_ACTIVITY'),
            text: confirm_message,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: this.$ml.get('DELETE_ACTIVITY_CONFIRM_BTN_TXT'),
            cancelButtonText: this.$ml.get('CANCEL'),
            customClass:{
                icon:'custom-delete-warning',
                cancelButton:'custom-delete-cancel-button'
            },
            reverseButtons:true
            }).then((result)=>{
                if(result.isConfirmed){
                  let schedule=event.schedule
              axios({
              method:'POST',
              url:'/deleteActivity',
              baseURL: this.baseUrl,
              data: {
                objId:schedule.id
              },
              withCredentials:true
            }).then((response)=>{
              if(response.data.status.code==0){
                  this.scheduleList.forEach((item,index) =>{
                    if(item.id==schedule.id){
                      this.scheduleList.splice(index,1)
                    }
                  })
                  }else{
                      Swal.fire({
                        title: this.$ml.get('WARNING'),
                        text: this.$ml.get('YOU_ARE_NOT_AUTHORIZED'),
                        icon: "warning"
              })
                  }
              }).catch(err=>{
                 console.log(err);
          })
        }
       })
       }
     },
     beforeUpdateSchedule(event){
     if(event.start){
        var date=new Date(Date.parse(event.start._date)).toJSON();
        // this.$root.$refs.newActivities.dataFilling()
        const template=this
        this.activities.forEach(function(activitie){
        if(activitie._id.$oid==event.schedule.id){
          // this.editLine(activitie)
           activitie.dueDate.$date=date
          //  template.editLines(activitie)
            let dataObj={}
            let updateObj={}
            updateObj.assignedTo=activitie.assignedTo
            updateObj.assignor=activitie.assignor
            updateObj.customerFileIds=activitie.customerFileIds
            updateObj.dealId=activitie.dealId
            updateObj.done=activitie.done
            updateObj.dueDate=activitie.dueDate
            updateObj.duration=activitie.duration
            updateObj.subject=activitie.subject
            // updateObj.orgId=activitie.orgId[0]._id
            updateObj.type=activitie.type
            if(activitie.contactId){
              updateObj.contactId=activitie.contactId[0]._id
              updateObj.orgId=activitie.contactId[0].organization
            }else{
              updateObj.contactId=activitie.contactId
            }
           
      
            dataObj["objId"]=event.schedule.id
            dataObj["updateObj"]=updateObj
         
               axios({
                method:'POST',
                url:`/updateActivity`,
                baseURL: template.baseUrl,
                data: dataObj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    template.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Aktivite güncellendi!',
                        text: res.data.status.desc
                    })
                   
                }else{
                    template.$notify({
                        group: 'foo',
                        type: 'error',
                        title: template.$ml.get('ERROR'),
                        text: res.data.status.desc
                    })
                }
                 
            })
            //axios bitiş
            
            //  template.$root.$refs.newActivities.listenStateStatus
        }
         
       })
      
         this.$root.$refs.Activities.getActivities()
             setTimeout(() => {
         this.$emit("updatedCalendar","updateCalendar")
       },1900);
       
     }
      if(!event.start){
         $('#add').modal('show')
      }
      if(!event.start){
        this.$root.$refs.newActivities.dataFilling()
        const vm=this
        this.activities.forEach(function(activitie){
          if(activitie._id.$oid==event.schedule.id){
            // this.editLine(activitie)
            vm.editLines(activitie)
          
            }
        })
            this.$emit("updatedCalendar","updateCalendar")
      }
     
   
     },

     tarih(tarih,fark){
          fark=((typeof fark).toLowerCase()=="string") ? fark : "00:00"
          let zamanlar=fark.split(':')
          tarih.setHours(tarih.getHours() + parseInt(zamanlar[0]))
          tarih.setMinutes(tarih.getMinutes() + parseInt(zamanlar[1]))
          let a=`${tarih.getHours()}:${tarih.getMinutes()}`
          return tarih.toJSON()
     },
     calendarF(){
       let filterEnd=""
       if( this.view=='month'){
         let tarihler=[this.dateRange + "-1T00:00:00.000Z",this.dateRange + "-31T23:59:59.000Z"]
          filterEnd={
            filter:{
              searcMode:"activities",
              name:"default",
            ands:[{
                    fieldName: "dueDate",
                    filterType: "activities",
                    operator: "equals",
                    value:{endDate:tarihler[1],startDate:tarihler[0]}
                  }]
                  }
         }
       }
       else if(this.view=='week'){
         let tarihler=this.dateRange.split(" ~ ")
         tarihler=[tarihler[0] + "T00:00:00.000Z",tarihler[1] + "T23:59:59.000Z"]
          filterEnd={
            filter:{
                searcMode:"activities",
                name:"default",
           ands:[{
                    fieldName: "dueDate",
                    filterType: "activities",
                    operator: "equals",
                    value:{endDate:tarihler[1],startDate:tarihler[0]}
                 }]
                }
         }
       }
       else if(this.view=='day'){
         let tarihler=this.dateRange
         tarihler=[tarihler + "T00:00:00.000Z",tarihler + "T23:59:59.000Z"]
          filterEnd={
            filter:{
                  searcMode:"activities",
                  name:"default",
            ands: [{
                    fieldName: "dueDate",
                    filterType: "activities",
                    operator: "equals",
                    value:{endDate:tarihler[1],startDate:tarihler[0]}
                  }]
                  }

         }
       }
       this.activities=[]
       this.scheduleList=[]
       this.filterDatas["pagingSize"]=this.pagingSize
       this.filterDatas["pagingOffset"]=this.pagingOffset
       filterEnd.filter.ands.push(...this.filterDatas["filter"]["ands"]);

        axios({
        method:'POST',
        url:'/getActivities',
        baseURL: this.baseUrl,
        data:this.filterDatas,
        //  data:this.filterDatas,
        //  data: {"pagingSize":40,"pagingOffset":0,"filter":{"searchMode":"activities","name":"default","ands":[{"filterType":"activities","fieldName":"done","operator":"equals","value":false}]}},
        withCredentials:true
        }).then((res)=>{
          return res
        }).then((res)=>{
          if(!res.data.status){
        } else {
          var html =[]
          for (var itemId in res.data.content.activities) {
            var activitie = res.data.content.activities[itemId]
            var userName
            for(var i in res.data.users){
              if(activitie.assignor.$oid===res.data.users[i]._id.$oid){
                userName=res.data.users[i].name+' '+res.data.users[i].surName
              }
            }
              this.activities.push(activitie)
            if(activitie.type==1){
               this.scheduleList.push({
               id: activitie._id.$oid,
              //  isAllDay:true,
               calendarId: '1',
               customStyle:'fas fa-phone-volume mb-1',
               title:activitie.subject,
               category: 'time',
               body:`<span class="fa fa-building mr-1"></span> ${(typeof activitie.orgId=='undefined')?'':activitie.orgId[0].name}<br>
               <span class="fas fa-people-arrows mr-1"></span> ${userName}<br>
               `,
               // start: '2018-10-18T17:30:00+09:00',
               start: new Date(Date.parse(activitie.dueDate['$date'])).toJSON(),
               end: this.tarih(new Date(Date.parse(activitie.dueDate['$date'])),activitie.duration),
               // '2021-08-24T11:30:00+03:00',
               //end: JSON.stringify(this.tarih(new Date(Date.parse(activitie.dueDate['$date'])),activitie.duration)),
               bgColor: '#52ba9f',
               color:"white",
               borderColor:"#52ba9f"

               // end: '2018-10-19T17:31:00+09:00'
           })
            }
            else if(activitie.type==2){
               this.scheduleList.push({
               customStyle:'fas fa-calendar-check',
               id: activitie._id.$oid,
               calendarId: '1',
               title: activitie.subject,
               category: 'time',
               dueDateClass: '',
               body:`<span class="fa fa-building mr-1"></span> ${(typeof activitie.orgId=='undefined')?'':activitie.orgId[0].name}<br>
               <span class="fas fa-people-arrows mr-1"></span> ${userName}<br>
               `,
               start: new Date(Date.parse(activitie.dueDate['$date'])).toJSON(),
               end: this.tarih(new Date(Date.parse(activitie.dueDate['$date'])),activitie.duration),
               bgColor: '#9666f6',
               color:"white",
               borderColor:'#9666f6',
           })
            }
            else if(activitie.type==3){
               this.scheduleList.push({
               customStyle:'fa fa-tasks ',
               id: activitie._id.$oid,
               calendarId: '1',
               title:activitie.subject,
               category: 'time',
               dueDateClass: '',
               body:`<span class="fa fa-building mr-1"></span> ${(typeof activitie.orgId=='undefined')?'':activitie.orgId[0].name}<br>
               <span class="fas fa-people-arrows mr-1"></span> ${userName}<br>
               `,
               start: new Date(Date.parse(activitie.dueDate['$date'])).toJSON(),
               end: this.tarih(new Date(Date.parse(activitie.dueDate['$date'])),activitie.duration),
               bgColor: '#49a7f8',
               color:"white",
               borderColor:'#49a7f8',
           })
            }
            else if(activitie.type==4){
               this.scheduleList.push({
               customStyle:'fa fa-envelope',
               id: activitie._id.$oid,
               kimlik:activitie._id.$oid,
               calendarId: '1',
               title: activitie.subject,
               category: 'time',
               dueDateClass: '',
               body:`<span class="fa fa-building mr-1"></span> ${(typeof activitie.orgId=='undefined')?'':activitie.orgId[0].name}<br>
               <span class="fas fa-people-arrows mr-1"></span> ${userName}<br>
               `,
               start: new Date(Date.parse(activitie.dueDate['$date'])).toJSON(),
               end: this.tarih(new Date(Date.parse(activitie.dueDate['$date'])),activitie.duration),
               bgColor: '#f6bd56',
               color:"white",
               borderColor:'#f6bd56',
           })
            }
         }
       }
     });
     },
     calendarFF(){
       this.uploadCalendarControl=0;
    axios.post(
            this.baseUrl + '/uploadCalendar',
            // formData,
            {
                  minRange:this.$refs.tuiCal.invoke('getDateRangeStart'),
                  maxRange:this.$refs.tuiCal.invoke('getDateRangeEnd')
            }
        )
      .then((res)=>{
       return res
     }).then((res)=>{
       if(!res.status){
         console.log('hop'); 
       } else {
        this.uploadCalendarControl=1
           for(var i=0; i<res.data.length;i++){
             if(res.data[i].startDate || res.data[i].start.dateTime){
              
                this.scheduleList.push({
                isReadOnly:true,
                id: res.data[i].id,
                calendarId: '1',
                customStyle:'fa fa-google',
                title: res.data[i].summary,
                category: 'time',
                dueDateClass: '',
                start:res.data[i].startDate || res.data[i].start.dateTime ,
                end: res.data[i].endDate || res.data[i].end.dateTime ,
                bgColor: '#db4a39',
                color:"white",
                borderColor:'#db4a39',
                
              })
             }
            else if(res.data[i].start.date ){
                var start=new Date(res.data[i].start.date).setHours(0)
               var end=new Date(res.data[i].end.date).setHours(0)
               if(start - end == -86400000){
                  start=new Date(res.data[i].start.date).setHours(8)
                end=new Date(res.data[i].start.date).setHours(18)
                  //  uploadCalendarControl=res.data[i].start.date
                 this.scheduleList.push({
                isReadOnly:true,
                id: res.data[i].id,
                calendarId: '1',
                customStyle:'fa fa-google',
                title: res.data[i].summary,
                category: 'time',
                dueDateClass: '',
                // start:res.data[i].start.date + "T05:00:00.000Z",
                // end: res.data[i].start.date + "T15:00:00.000Z",
                 start:start,
                end: end,
                bgColor: '#db4a39',
                color:"white",
                borderColor:'#db4a39',
                
              })
               }
               else{
                var eend=new Date(res.data[i].end.date)
                eend.setDate(eend.getDate() - 1)
                eend.setHours(23)
                this.scheduleList.push({
                isReadOnly:true,
                id: res.data[i].id,
                calendarId: '1',
                customStyle:'fa fa-google',
                title: res.data[i].summary,
                category: 'time',
                dueDateClass: '',
                // start:res.data[i].start.date + "T05:00:00.000Z",
                // end: res.data[i].start.date + "T15:00:00.000Z",
                 start:start,
                end: eend,
                bgColor: '#db4a39',
                color:"white",
                borderColor:'#db4a39',
                
              })
               }
             
            } 
             
           }
           
        //  }
       }
     });
     }
   },
   mounted() {
     this.setRenderRangeText();
   }
 }
</script>

<style scoped>
.borderGri{
  border: 1px solid #e7e7e8;
}
.aciklamaRengi{
  color: rgba(51, 51, 51, 0.80);
}
.w64{
  width: 64px !important;
}
.w36{
  width: 36px !important;
}
.w130{
  width: 130px !important;
}
.mailColor{
  background-color:#f6bd56 !important;
}
.callColor{
  background-color: #52ba9f !important;
}
.taskColor{
  background-color: #49a7f8 !important;
}
.appointmentColor{
  background-color: #9666f6 !important;
}
.googleColor{
  background-color: #db4a39 !important;
}
.move-day{
    font-size: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500px;
}
/* .btn-crm-secondary-calendar{
  background-color: transparent;
  color: #1991EB;
}
.btn-crm-secondary-calendar:hover {
  background-color: #1991eb;
  color: #fff;
}
.btn-crm-secondary-calendar:active {
  background-color: red;
  color: #fff;
} */
.activityFilterr .active {
        background-color: #1991eb;
        color: #fff;
    }
.activityFilterr button {
       background-color: transparent;
       color: #1991EB;
    }
.activityFilterr button:hover{
  background-color: #D1E9FB;
  color: #1991eb;
}






</style>
